/* eslint-disable @next/next/no-img-element */
import {
  DrawDetailItemFragment,
  DrawTableItemFragment,
  DrawTeamItemFragment,
} from '@amf/shared/types/graphql';
import classNames from 'classnames';

type TeamProps = {
  team: DrawTeamItemFragment;
};

function Team({ team }: TeamProps) {
  return (
    <div className='flex items-center gap-3 px-3 lg:px-4 py-4'>
      {team.team.club.brandUrl ? (
        <img
          src={team.team.club.brandUrl}
          alt={team.team.club.name}
          className='w-6 h-6 object-cover rounded-b-full border border-neutral-200'
        />
      ) : (
        <div className='w-6 h-6 bg-neutral-200 rounded-full' />
      )}
      <h4 className='m-0 text-neutral-900 font-primary normal-case font-bold'>{team.team.name}</h4>
    </div>
  );
}

type GroupProps = {
  table: DrawTableItemFragment;
  color: string;
};

function Group({ table, color }: GroupProps) {
  return (
    <div
      style={{ borderColor: color }}
      className='bg-white text-neutral-950 border rounded-xl overflow-hidden shadow'
    >
      <div style={{ backgroundColor: color }} className='px-3 py-2 lg:py-2 lg:px-4'>
        <h3 className='text-base sm:text-lg font-black normal-case font-primary text-wmf-black m-0'>
          {table.name}
        </h3>
      </div>
      <div className='flex flex-col divide-y divide-zinc-100'>
        {table.teams.map(team => (
          <Team key={team.id} team={team} />
        ))}
      </div>
    </div>
  );
}

const COLORS = [
  '#f87171',
  '#fbbf24',
  '#a3e635',
  '#34d399',
  '#38bdf8',
  '#818cf8',
  '#c084fc',
  '#ec4899',
];

type HomeGroupsProps = {
  draw: DrawDetailItemFragment;
};

function HomeGroups({ draw }: HomeGroupsProps) {
  return (
    <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-6'>
      {draw.tables.map((table, key) => (
        <Group key={table.id} table={table} color={COLORS[key]} />
      ))}
    </div>
  );
}

export default HomeGroups;
